import setUserFilterData from './actions';

export default {
  setUserFilterData,
};
